import { render, staticRenderFns } from "./MiscDemo.vue?vue&type=template&id=506cb6fc&scoped=true&"
import script from "./MiscDemo.vue?vue&type=script&lang=js&"
export * from "./MiscDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506cb6fc",
  null
  
)

export default component.exports